export default {
  DASHBOARD: 'dashboard',
  AUTH: 'user_auth',
};
